import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=6ec48fb4&scoped=true&"
import script from "./BaseLayout.vue?vue&type=script&lang=ts&"
export * from "./BaseLayout.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=6ec48fb4&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-c5444c0a66/0/cache/vue-loader-npm-15.9.1-90a0e5830b-a9a3ffbe3c.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec48fb4",
  null
  
)

export default component.exports